import { formatDate, formatAmount, imgToBase64 } from './formatters'
import { commisionerNormal } from '../assets/fonts/pdfMakeFonts/CommissionerNormal'
import { commisionerBold } from '../assets/fonts/pdfMakeFonts/CommisionerBold'
import pdfMake from 'pdfmake/build/pdfmake'
import pngLogo from '../assets/images/logo.png'
import pdfFonts from 'pdfmake/build/vfs_fonts'

pdfMake.vfs = pdfFonts.pdfMake.vfs
window.pdfMake.vfs['Commissioner-Regular.ttf'] = commisionerNormal
window.pdfMake.vfs['Commissioner-Bold.ttf'] = commisionerBold

export async function generatePDF(paymentData, profile) {
    const convertedImage = await imgToBase64(pngLogo)
    pdfMake.fonts = {
        Commissioner: {
            normal: 'Commissioner-Regular.ttf',
            bold: 'Commissioner-Bold.ttf',
        },
    }

    const docDefinition = {
        defaultStyle: {
            font: 'Commissioner',
        },
        header: [
            {
                image: convertedImage,
                width: 240,
            },
        ],
        content: [
            {
                text: `Αρ.Απόδειξης: ${paymentData.systemCode}`,
                style: 'header',
                margin: [0, 35, 0, 30],
            },
            {
                text: `Ημερομηνία Δημιουργίας: ${formatDate(
                    paymentData.paymentDate
                )}`,
                style: 'mainText',
                margin: [0, 15],
            },
            {
                text: `Κωδικός πληρωμής: ${paymentData.paymentCode}`,
                style: 'mainText',
                margin: [0, 15],
            },
            {
                text: `Α.Φ.Μ. Οφειλέτη: ${profile.taxid}`,
                style: 'mainText',
                margin: [0, 15],
            },
            {
                text: `Ονοματεπώνυμο Οφειλέτη: ${profile.firstName} ${profile.lastName}`,
                style: 'mainText',
                margin: [0, 15],
            },
            {
                style: 'paymentTable',
                table: {
                    headerRows: 1,
                    body: [
                        [
                            { text: 'Αιτιολογία', style: 'tableHeader' },
                            { text: 'Ποσό', style: 'tableHeader' },
                        ],
                        [
                            `${paymentData.description}`,
                            `${formatAmount(paymentData.amount)}`,
                        ],
                    ],
                },
                layout: 'headerLineOnly',
            },
        ],
        footer: [
            {
                text: 'Δήμος Δυτικής Λέσβου',
                margin: [0, 10],
                alignment: 'center',
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
            },
            mainText: {
                fontSize: 10,
                alignment: 'left',
                bold: true,
                margin: [0, 0, 0, 35],
            },
            paymentTable: {
                margin: [0, 25, 0, 35],
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'black',
            },
            tableExample: {
                margin: [0, 5, 0, 35],
            },
        },
    }
    const pdfDocGenerator = pdfMake.createPdf(docDefinition)
    const filename = `GovPay receipt - ${paymentData.systemCode}.pdf`
    pdfDocGenerator.download(filename)
}

export async function generateNoticePDF(debts, profile) {
    const convertedImage = await imgToBase64(pngLogo)

    pdfMake.fonts = {
        Commissioner: {
            normal: 'Commissioner-Regular.ttf',
            bold: 'Commissioner-Bold.ttf',
        },
    }

    const noticeId = `${profile.taxid}-${new Date().getTime()}`
    const tableData = debts.map(debt => {
        return [
            debt.paymentCode,
            debt.systemCode,
            debt.description ?? '-',
            formatAmount(debt.amount),
            debt.amountString ?? '-',
            formatDate(debt.expirationDate),
            debt.status,
        ]
    })

    const docDefinition = {
        defaultStyle: {
            font: 'Commissioner',
        },
        header: [
            {
                image: convertedImage,
                width: 240,
            },
        ],
        content: [
            {
                text: `Ειδοποιητήριο: ${noticeId}`,
                style: 'header',
                margin: [0, 35, 0, 30],
            },
            {
                text: `Ημερομηνία Δημιουργίας: ${formatDate(
                    new Date().getUTCDate()
                )}`,
                style: 'mainText',
                margin: [0, 15],
            },
            {
                text: `Α.Φ.Μ. Οφειλέτη: ${profile.taxid}`,
                style: 'mainText',
                margin: [0, 15],
            },
            {
                text: `Ονοματεπώνυμο Οφειλέτη: ${profile.firstName} ${profile.lastName}`,
                style: 'mainText',
                margin: [0, 15],
            },
            {
                style: 'debtsTable',
                table: {
                    headerRows: 1,
                    widths: ['*', 50, '*', '*', '*', '*', '*'],
                    body: [
                        [
                            { text: 'Κωδικός πληρωμής', style: 'tableHeader' },
                            { text: 'Κωδικός Govpay', style: 'tableHeader' },
                            { text: 'Αιτιολογία', style: 'tableHeader' },
                            { text: 'Ποσό', style: 'tableHeader' },
                            { text: 'Ποσό ολογράφως', style: 'tableHeader' },
                            {
                                text: 'Καταληκτική ημ/νία πληρωμής',
                                style: 'tableHeader',
                            },
                            { text: 'Κατάσταση', style: 'tableHeader' },
                        ],
                        ...tableData,
                    ],
                },
                layout: 'headerLineOnly',
            },
        ],
        footer: [
            {
                text: 'Δήμος Δυτικής Λέσβου',
                margin: [0, 10],
                alignment: 'center',
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: 'center',
            },
            mainText: {
                fontSize: 10,
                alignment: 'left',
                bold: true,
                margin: [0, 0, 0, 35],
            },
            debtsTable: {
                margin: [0, 25, 0, 35],
            },
            tableHeader: {
                bold: true,
                fontSize: 10,
                color: 'black',
            },
            tableExample: {
                margin: [0, 5, 0, 35],
            },
        },
    }
    const pdfDocGenerator = pdfMake.createPdf(docDefinition)
    const filename = `GovPay Notice - ${noticeId}.pdf`

    pdfDocGenerator.download(filename)
}
